import React from "react";
import "./vocational.css";

function Vocational() {
  return (
    <div>
      <div>
        <h2 className="vocational-training">Vocational training</h2>
      </div>
      <div className="container">
        <p>
          Deepti provides vocational training for young adults with special
          needs who are above eighteen years. It has registration under the
          ministry of social justice. Deepti Vocational Training Centre gives
          training in Computer education in collaboration with AMBA computer
          Centre Bangalore, with a special focus on Data entry, and with an aim
          to prepare them for job. Other activities includes, training in making
          door mats, paper bags, jewelry, detergents, candle, agriculture and
          cooking.
        </p>
      </div>
    </div>
  );
}

export default Vocational;
